import { GET_RACKS, GET_RACKS_SUCCESS, GET_RACKS_ERROR} from './actionTypes';

const initialState = {
    errorGetRacks: "",
    loadingGetRacks: false,
    racks: null,
    successRacks: ""
}

const getRacks = (state = initialState, action) => {

    switch (action.type) {
        case GET_RACKS:
            state = {
                ...state,
                loadingGetRacks: true
            }
            break;
        case GET_RACKS_SUCCESS:
          
            state = {
                ...state,
                loadingGetRacks: false,
                racks: action.payload.racks, 
                successRacks: action.payload.message
            }
       
            break;
        case GET_RACKS_ERROR:
            state = { ...state, errorGetRacks: action.payload, loadingGetRacks: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getRacks;